import { ErrorMessage } from "@hookform/error-message"
import { useFormContext } from "react-hook-form"
import InputGroup from "../../../../common/form/inputGroup"
import Label from "../../../../common/form/label"
import Checkmark from "../../../../common/icons/checkmark"

const options = [
  {
    label: "Biologi (Bi)",
    value: 1,
    defaultChecked: false
  },
  {
    label: "Idrott och hälsa (Idh)",
    value: 2,
    defaultChecked: false
  },
  {
    label: "Slöjd (Sl)",
    value: 3,
    defaultChecked: false
  },
  {
    label: "Samhällskunskap (Sh)",
    value: 4,
    defaultChecked: false
  },
  {
    label: "Svenska (Sv)",
    value: 5,
    defaultChecked: false
  }
]

export function SubjectLabel({ subject }) {
  const subjects =
    subject
      .map((subject) => {
        return options.find((option) => option.value == subject)?.label
      })
      .join(", ") || "Inga ämnen valda"
  return <>{subjects}</>
}

export function Subject() {
  const {
    watch,
    register,
    formState: { errors }
  } = useFormContext()

  const checked = watch("subject") || []

  return (
    <InputGroup>
      <Label name="subject">Ämnen vi planerar att involvera</Label>
      <div className="flex flex-wrap gap-4">
        {options.map((option, index) => (
          <div key={index} className="relative pl-8">
            <input
              className="cursor-pointer h-6 w-6 absolute top-0.5 left-0 appearance-none rounded-[4px] border border-solid border-black-100/20 before:pointer-events-none before:absolute before:h-6 before:w-6 before:scale-0 before:rounded-[4px] before:bg-transparent before:opacity-0 before:shadow-[0px_0px_0px_13px_transparent] before:content-[''] checked:border-summer-green-100 checked:bg-summer-green-100"
              type="checkbox"
              id={`subject-${index}`}
              value={option.value}
              defaultChecked={option.defaultChecked}
              {...register("subject")}
            />
            <label
              className="text-base cursor-pointer select-none whitespace-nowrap"
              htmlFor={`subject-${index}`}>
              {checked.includes(option.value.toString()) && (
                <Checkmark className="w-4 absolute top-1.5 left-1" />
              )}
              {option.label}
            </label>
          </div>
        ))}
      </div>
      <ErrorMessage
        errors={errors}
        name="subject"
        render={({ message }) => (
          <p className="mt-2 text-sm text-red-100">{message}</p>
        )}
      />
    </InputGroup>
  )
}
